import { Share, Sparkles } from "lucide-react";

import { Button } from "@/components/ui/button";
import SaveButton from "@/components/ui/SaveButton";
import type { Product } from "@/lib/product-utils";

export interface PdpActionIconsProps {
  product: Product;
  savedProductId: string;
  onOpenMoreLike: () => void;
  onShare: () => void;
  className: string;
  shareIconClassName: string;
  showShareTooltip?: boolean;
  onShareTooltipChange?: (show: boolean) => void;
}

export function PdpActionIcons({
  product,
  savedProductId,
  onOpenMoreLike,
  onShare,
  className,
  shareIconClassName,
  showShareTooltip = false,
  onShareTooltipChange,
}: PdpActionIconsProps) {
  const shareButton = (
    <Button
      variant="ghost"
      size="sm"
      className="bg-transparent p-2 text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-900"
      onClick={onShare}
      aria-label="Share product"
      onMouseEnter={onShareTooltipChange ? () => onShareTooltipChange(true) : undefined}
      onMouseLeave={onShareTooltipChange ? () => onShareTooltipChange(false) : undefined}
    >
      <Share className={shareIconClassName} />
    </Button>
  );

  return (
    <div className={className}>
      <Button
        variant="ghost"
        size="sm"
        className="bg-transparent p-2 text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-900"
        onClick={onOpenMoreLike}
        aria-label="More like this"
      >
        <Sparkles className="h-5 w-5" />
      </Button>
      <SaveButton productId={savedProductId} product={product} variant="icon" className="!p-2" />
      {onShareTooltipChange ? (
        <div className="relative">
          {shareButton}
          {showShareTooltip && (
            <div className="absolute bottom-full left-1/2 z-30 mb-2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white">
              Share
            </div>
          )}
        </div>
      ) : (
        shareButton
      )}
    </div>
  );
}
